module.exports = __webpack_public_path__ + "media/src/assets/store-0ea8ec2eec1d474d3d7fef7080e13e0b.svg";